export default __webpack_public_path__ + "static/media/CustoImage (5).62da9c03.png";